import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref, watch } from 'vue';
import RequestLoading from "@/components/Loading/RequestLoading.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    let requestNum = ref(0); // 请求数量
    let requestTime = ref(0); // 已请求时长 计数（0.5秒为一个单位）
    let timer = ref();
    onMounted(() => {
      const loadDom = document.getElementById("Loading");
      loadDom && loadDom.remove();
      Window.requestAdjust = val => {
        if (val === 0) {
          requestNum.value = 0;
        } else {
          requestNum.value += val;
        }
      };
    });
    const requestTimeCount = () => {
      if (requestNum.value > 0) {
        requestTime.value++;
        timer.value = setTimeout(() => {
          requestTimeCount();
        }, 500);
      } else {
        if (timer.value) clearTimeout(timer.value);
        requestTime.value = 0;
      }
    };
    watch(() => requestNum, val => {
      if (val.value > 0) {
        if (timer.value) return;
        requestTimeCount();
      } else {
        if (timer.value) clearTimeout(timer.value);
        requestTime.value = 0;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(RequestLoading, {
        hideRound: _unref(requestTime) <= 1
      }, null, 8, ["hideRound"]), [[_vShow, _unref(requestNum) > 0]]), _createVNode(_component_router_view)], 64);
    };
  }
});